<template>
    <el-menu default-active="2" style="min-height: 100%; height:100%"
        background-color="#F2F6FC"
        text-color="#333"
        active-text-color="#409EFF" router>
        <el-menu-item index="/console/user" style="margin-top: 20px; padding-left: 10px"><i class="el-icon-menu" style="padding-left: 0px"></i>用户管理</el-menu-item>
        <el-menu-item index="/console/device" style="padding-left: 10px"><i class="el-icon-setting"></i>设备管理</el-menu-item>
        <el-menu-item index="/console/server" style="padding-left: 25px"><i class="el-icon-upload" style="padding-left: 0px"></i>服务器管理</el-menu-item>
        <el-menu-item index="/console/language" style="padding-left: 15px"><i class="el-icon-location"></i>国家/语言</el-menu-item>
        <el-menu-item index="/console/data" style="padding-left: 10px"><i class="el-icon-star-on"></i>数据管理</el-menu-item>
        <el-menu-item index="/console/about" style="padding-left: 10px"><i class="el-icon-more"></i>版本信息</el-menu-item>
        <!--<el-submenu index="2">
            <template slot="title"><i class="el-icon-document"></i>数据管理</template>
            <el-menu-item index="/consdevicearea">设备列表</el-menu-item>
            <el-menu-item index="/console/deviceManage">会话列表</el-menu-item>
        </el-submenu>
        <el-submenu index="3">
            <template slot="title"><i class="el-icon-plus"></i>添加数据</template>
            <el-menu-item index="/console/addDevice">添加设备</el-menu-item>
            <el-menu-item index="/console/language">地区/语言</el-menu-item>
        </el-submenu>
        <el-submenu index="4">
            <template slot="title"><i class="el-icon-star-on"></i>图表</template>
            <el-menu-item index="/console/distribute">用户分布</el-menu-item>
            <el-menu-item index="/console/statistics">访问统计</el-menu-item>
        </el-submenu>
        <el-submenu index="5">
            <template slot="title"><i class="el-icon-edit"></i>编辑</template>
            <el-menu-item index="vueEdit">文本编辑</el-menu-item>
        </el-submenu>
        <el-submenu index="6">
            <template slot="title"><i class="el-icon-setting"></i>设置</template>
            <el-menu-item index="/console/user">个人信息</el-menu-item>
            <el-menu-item index="/console/users">用户管理</el-menu-item>
            <el-menu-item index="/console/permissions">权限管理</el-menu-item>
        </el-submenu>
        <el-submenu index="7">
            <template slot="title"><i class="el-icon-warning"></i>日志记录</template>
            <el-menu-item index="/console/logs">日志记录</el-menu-item>
        </el-submenu>-->

    </el-menu>
</template>

<script>
// import { mapState } from 'vuex';
import { Message } from 'element-ui';

export default {
    name: 'Aside',
    // computed: mapState({
    //     user: state => state.user
    // }),
    // components: {
    //     Main,
    //     home
    // },
    data() {
        return {
            currentPath: '/console/welcome',
            currentPathName: 'Welcome',
            isCollapse: false
        }  
    },
    methods: {
        handleOpen(key, keyPath) {
            console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
            console.log(key, keyPath);
        },
        collapse: function () {
            this.isCollapse = !this.isCollapse;
        },
    },
    watch: {
        '$route' (to, from) { //监听路由改变
            this.currentPath = to.path
            this.currentPathName = to.name
            console.log(to.path)
            console.log(to.name)
        }
    },
    mounted() {
        var currentPathName
    }
}
</script>

<<style>
/* .el-menu--dark .el-menu-item, .el-menu--dark .el-submenu__title {
    color: #bfcbd9;
} */
</style>



// WEBPACK FOOTER //
// src/components/Aside.vue